import React from 'react';
import {
  LinkedInIcon,
  EmailIcon,
  CallIcon,
  LanguageIcon,
  WhatsAppIcon,
  TwitterIcon,
  FacebookIcon,
  InstagramIcon,
  YouTubeIcon,
  TikTokIcon,
  LocationOnIcon,
  PersonIcon,
  BusinessIcon,
  StorefrontIcon
} from 'icons/materialIcons';

const getIconForType = (type) => {
  const iconColors = {
    LinkedIn: '#0077B5',
    Email: '#EA4335',
    Call: '#34A853',
    Website: '#4285F4',
    WhatsApp: '#25D366',
    Twitter: '#1DA1F2',
    Facebook: '#1877F2',
    Instagram: '#E1306C',
    YouTube: '#FF0000',
    TikTok: '#000000',
    Address: '#FF5722',
    Company: '#673AB7',
    'Products & Services': '#FF9800',
    default: '#666666'
  };

  const iconComponents = {
    LinkedIn: <LinkedInIcon sx={{ color: iconColors.LinkedIn }} />,
    Email: <EmailIcon sx={{ color: iconColors.Email }} />,
    Call: <CallIcon sx={{ color: iconColors.Call }} />,
    Website: <LanguageIcon sx={{ color: iconColors.Website }} />,
    WhatsApp: <WhatsAppIcon sx={{ color: iconColors.WhatsApp }} />,
    Twitter: <TwitterIcon sx={{ color: iconColors.Twitter }} />,
    Facebook: <FacebookIcon sx={{ color: iconColors.Facebook }} />,
    Instagram: <InstagramIcon sx={{ color: iconColors.Instagram }} />,
    YouTube: <YouTubeIcon sx={{ color: iconColors.YouTube }} />,
    TikTok: <TikTokIcon sx={{ color: iconColors.TikTok }} />,
    Address: <LocationOnIcon sx={{ color: iconColors.Address }} />,
    Company: <BusinessIcon sx={{ color: iconColors.Company }} />,
    'Products & Services': <StorefrontIcon sx={{ color: iconColors['Products & Services'] }} />,
    default: <PersonIcon sx={{ color: iconColors.default }} />
  };

  return iconComponents[type] || iconComponents.default;
};

export default getIconForType;